// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"NavItems_iconWrapper__3LF5V"};